export default defineNuxtRouteMiddleware(async (to) => {
	// Skip if /metrics or /health
	if (to.path === '/metrics' || to.path === '/health') {
		return
	}

	// Check if the cookie is set
	try {
		const isAuthenticated = await useAuth().isAuthenticated

		// If the cookie is not set and the route is not in the unauthenticatedRoutes array, redirect to the login page
		if (!isAuthenticated && !unauthenticatedRoutes.includes(to.path)) {
			console.log('No session, redirecting to /')

			// useAuth().logoutUser()
			return navigateTo('/')
		}

		const { user } = useAuth()
		if (isAuthenticated) {
			umIdentify({
				uid: user?.id,
				email: user?.email,
				name: `${user?.firstName} ${user?.lastName}`,
				organisationId: user?.organisation?.id,
				organisationName: user?.organisation?.name,
				role: user?.role,
			})
		}

		if (isAuthenticated && unauthenticatedRoutes.includes(to.path)) {
			if (!user) {
				return navigateTo('/')
			}

			if (!user.organisation) {
				return navigateTo('/organisation')
			}
			const domainDashboard = user.organisation.domain
			return navigateTo(`/${domainDashboard}`)
		}

		// if the user is authenticated and the route is /departments or /users or /organisation, but the user is not an admin or the first login is not done, redirect to the dashboard
		if (
			isAuthenticated &&
			(to.path === '/departments' || to.path === '/users' || to.path === '/organisation')
		) {
			if (!user) {
				return navigateTo('/')
			}

			if (user.role !== 'admin' || user.firstLoginDone) {
				return navigateTo(`/${user.organisation?.domain}`)
			}
		}
	} catch (error) {
		// navigateTo('/')
		console.warn('Error getting the cookie: ', error)
		throw error
	}
})
